import React from 'react'
import { Routes, Route } from 'react-router-dom'
import GetAssessment from './GetAssessment'
import { TemplatesPage } from './TemplatesPage'
import { CreateAssessmentPage } from './CreateAssessmentPage'
import { QuestionBuilderPage } from './QuestionBuilderPage'
import { PreviewAssessmentPage } from './PreviewAssessmentPage'
import { AssessmentViewPage } from './AssessmentViewPage'

export const AssessmentRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='' element={<GetAssessment />} />
      <Route path='templates' element={<TemplatesPage />} />
      <Route path='create/:templateId' element={<CreateAssessmentPage />} />
      <Route path='questions/:assessmentId' element={<QuestionBuilderPage />} />
      <Route path='preview/:assessmentId' element={<PreviewAssessmentPage />} />
      <Route path=':assessmentId' element={<AssessmentViewPage />} />
    </Routes>
  )
}
